// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { RecoveryContext } from '../recoveryContext';
import { useStores } from 'hooks/useStores';
import {INVALIDATION_TIP, REGEX} from "../../../const/validation";

const schema = yup.object().shape({
	email: yup
		.string()
		.required(INVALIDATION_TIP.FIELD_REQUIRED)
		.matches(
			REGEX.VALID_EMAIL,
			INVALIDATION_TIP.INCORRECT_EMAIL
		),
});

export default function RecoveryStep1(props) {
	const { setContextEmail } = useContext(RecoveryContext);
	const [wrongEmail, setWrongEmail] = useState(false);
  const { api } = useStores()
	const changeStep = () => {
		props.nextStep(2);
	};

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		mode: 'onBlur',
		resolver: yupResolver(schema),
	});

	const [response, setResponse] = useState({
		status: false,
	});
	const onSubmit = data => {
		setWrongEmail(false);
		api.auth.postRestorePassword(data)
			.then(res => {
				setContextEmail(data.email);
				setResponse(res);
			})
			.catch(err => {
				setWrongEmail(true);
				if (err.response.status === 500) {

				};
			});
	};

	useEffect(() => {
		if (response.status === true) changeStep();
	}, [response]);

	return (
		<div>
			<h3 className='lkLogin-main__step'>Шаг 1</h3>
			<h1 className='lkLogin-main__title'>Восстановление</h1>
			{wrongEmail && (
				<div className='lkLogin-incorrectLogin'>
					аккаунта с таким email не существует
				</div>
			)}
			<form className='lkLogin-form' onSubmit={handleSubmit(onSubmit)}>
				<div className='lkLogin-form-item'>
					<label htmlFor='email'>
						Email<span className='lkLogin-form__span'>*</span>
					</label>
					<input
						autoFocus
						{...register('email')}
						id='email'
						name='email'
						type='email'
						className='lkLogin-input'
					/>
					<p className='lkLogin-form__err'>{errors.email?.message}</p>
				</div>
				<div>
					<button className='lkLogin-form-btn lkLogin-form-item' type='submit'>
						Далее
					</button>
				</div>
			</form>
		</div>
	);
}
